var field_helps = [];
var hide_fields = [];
var selectedFieldVariants = [];

/*

function countProperties(obj) {
    var count = 0;
    for(var prop in obj){if(obj.hasOwnProperty(prop)){++count};}
    return count;
}

function numericSort(a, b){ return (parseFloat(a)-parseFloat(b)); }

var temporaryBox, filterForm, fieldFilters;

var field_helps = [];
var hide_fields = [];
var selectedFieldVariants = [];

var show_filter = true;
var pageProducts = [];
var productPlaces = [];
var showedProducts = [];

var filterFields, activeFilterFields;

var getParamsFromUrl = true;
var setList = false;

//var itemsSearch = '';

function rebuildFilter(){
	
	if(getParamsFromUrl){
		
		getParamsFromUrl = false;
		
		var params = location.href.split('#');
		if(params[1]){
			
			var list = false;
			
			params = params[1].split('&');
			
			for(var i in params){
				
				if(params.hasOwnProperty(i) && typeof(params[i][1])!='object' && typeof(params[i][1])!='function'){
					
					params[i] = params[i].split('=');
					
					if(params[i][1] && params[i][0]!='sort_by' && params[i][0]!='search' && params[i][0]!='list_type' && params[i][0]!='sort_method' && params[i][0]!='onpage' && params[i][0]!='list' && params[i][0]!='price'){
						
						params[i][0] = decodeURIComponent(params[i][0]);
						params[i][1] = decodeURIComponent(params[i][1]);
						
						params[i][1] = params[i][1].split('||');
						
						selectedFieldVariants[params[i][0]] = [];
						
						for(var x in params[i][1]){
							if(params[i][1].hasOwnProperty(x) && typeof(params[i][1][x])!='object' && typeof(params[i][1][x])!='function'){
								selectedFieldVariants[params[i][0]][params[i][1][x]] = true;
							}
						}
						
					}else if(params[i][0]=='onpage'){
						
						for(var x in productPlaces){
							if(productPlaces.hasOwnProperty(x)){
								productPlaces[x]['on_page'] = parseInt(params[i][1]);
							}
						}
						
					}else if(params[i][0]=='list_type'){
						
						for(var x in productPlaces){
							if(productPlaces.hasOwnProperty(x)){
								productPlaces[x]['list_type'] = params[i][1];
							}
						}
						
					}else if(params[i][0]=='sort_by'){
						
						for(var x in productPlaces){
							if(productPlaces.hasOwnProperty(x)){
								productPlaces[x]['sort_by'] = params[i][1];
							}
						}
						
					}else if(params[i][0]=='sort_method'){
						
						for(var x in productPlaces){
							if(productPlaces.hasOwnProperty(x)){
								productPlaces[x]['sort_method'] = params[i][1];
							}
						}
						
					}else if(params[i][0]=='search'){
						
						for(var x in productPlaces){
							if(productPlaces.hasOwnProperty(x)){
								productPlaces[x]['search'] = params[i][1];
							}
						}
						
					}else if(params[i][0]=='list'){
						
						setList = parseInt(params[i][1]);
						
					}else if(params[i][0]=='price'){
						
						var tmp = params[i][1].split('-');
						
						document.getElementById('minCost').value = parseInt(tmp[0]);
						document.getElementById('maxCost').value = parseInt(tmp[1]);
						
						jQuery("#priceSlider").slider({
							values: [parseInt(tmp[0]), parseInt(tmp[1])]
						});
						
					}
					
				}
				
			}
			
		}
		
	}
	
	if(!pageProducts || !pageProducts.length){return false;}
	
	if(!temporaryBox){temporaryBox = document.getElementById('temporaryBox');}
	if(!filterForm){filterForm = document.getElementById('filterForm');}
	if(!fieldFilters){fieldFilters = document.getElementById('fbItem');}
	
	//----------- Getting filter fields -------------|
		
		filterFields = [];
		
		for(var i in filterForm.elements){
			if(typeof(filterForm.elements[i])=='object' && filterForm.elements[i] && filterForm.elements[i].name){
				//alert(filterForm.elements[i].name+': '+filterForm.elements[i].value);
				filterFields[filterForm.elements[i].name] = filterForm.elements[i].value;
			}
		}
		
	//----------- Getting filter fields -------------|
	
	
	//--------- Searching products in price range ----------|
		
		showedProducts = [];
		
		for(var i in pageProducts){
			
			if(pageProducts[i]['obj'] && document.getElementById(pageProducts[i]['obj'])){
				
				var obj = document.getElementById(pageProducts[i]['obj']);
				
				obj.style.display = 'none';
				temporaryBox.appendChild(obj);
				
				productVisible = false;
				
				if(pageProducts[i]['price']>=filterFields['minCost'] && pageProducts[i]['price']<=filterFields['maxCost']){
					productVisible = true;
				}
				
				if(productVisible){
					showedProducts.push(pageProducts[i]);
				}
				
			}
			
		}
		
	//--------- Searching products in price range ----------|
	
	
	
	//--------- Generating filter fields ----------|
		
		filterFields = [];
		activeFilterFields = [];
		
		for(var i in showedProducts){
			
			if(showedProducts[i]['obj'] && showedProducts[i]['filter_params']){
				for(var field in showedProducts[i]['filter_params']){
					
					if(!filterFields[field]){
						filterFields[field] = [];
					}
					
					filterFields[field][showedProducts[i]['filter_params'][field]] = true;
					
				}
			}
		}
		
		fieldFilters.innerHTML = '';
		
		for(var fieldName in filterFields){
			
			if(filterFields[fieldName] && typeof(filterFields[fieldName])=='object' && countProperties(filterFields[fieldName])>1){
				
				activeFilterFields[fieldName] = true;
				
				var mainLi = document.createElement('li');
					
					var strong = document.createElement('strong');
						
						strong.className = 'filter_title';
						strong.appendChild(document.createTextNode(fieldName));
						
					mainLi.appendChild(strong);
					
					var ul = document.createElement('ul');
					ul.id = fieldName+'_variants';
					ul.className = 'filter_item__variants';
						
						//----------- Resorting fields -----------|
							
							var tmpVariants = [];
							
							for(var variantName in filterFields[fieldName]){
								if(filterFields[fieldName][variantName] && typeof(filterFields[fieldName][variantName])!='function'){
									tmpVariants.push(variantName);
								}
							}
							
							if(parseFloat(tmpVariants[0]) && parseFloat(tmpVariants[1])){
								tmpVariants.sort(numericSort);
							}else{
								tmpVariants.sort();
							}
							
							var tmpVariants_new = [];
							
							for(var i in tmpVariants){
								if(tmpVariants[i] && typeof(tmpVariants[i])!='function'){
									tmpVariants_new[tmpVariants[i]] = true;
								}
							}
							
							filterFields[fieldName] = tmpVariants_new;
							
						//----------- Resorting fields -----------|
						
						for(var variantName in filterFields[fieldName]){
							
							if(filterFields[fieldName][variantName] && typeof(filterFields[fieldName][variantName])!='function' && variantName!='-'){
								
								var li = document.createElement('li');
									
									var a = document.createElement('a');
										
										var status = (selectedFieldVariants[fieldName] && selectedFieldVariants[fieldName][variantName])?'on':'off';
										
										a.className = status=='off'?'':'filter_item__variants_on';
										a.setAttribute('field', fieldName);
										a.setAttribute('variant', variantName);
										a.setAttribute('status', status);
										a.onclick = function(){
											
											var newStatus = this.getAttribute('status')=='off'?'on':'off';
											this.setAttribute('status', newStatus);
											
											if(newStatus=='on'){
												if(!selectedFieldVariants[this.getAttribute('field')]){selectedFieldVariants[this.getAttribute('field')] = [];}
												selectedFieldVariants[this.getAttribute('field')][this.getAttribute('variant')] = true;
											}else if(selectedFieldVariants[this.getAttribute('field')][this.getAttribute('variant')]){
												delete selectedFieldVariants[this.getAttribute('field')][this.getAttribute('variant')];
												if(!countProperties(selectedFieldVariants[this.getAttribute('field')])){delete selectedFieldVariants[this.getAttribute('field')];}
											}
											
											rebuildAllProducts();
											
											return false;
											
										}
										
										a.href = location.href;
										a.appendChild(document.createTextNode(variantName));
										
									li.appendChild(a);
									
								ul.appendChild(li);
								
							}
							
						}
						
					mainLi.appendChild(ul);
					
				fieldFilters.appendChild(mainLi);
				
			}
			
		}
		
	//--------- Generating filter fields ----------|
	
}



function rebuildAllProducts(){
	
	rebuildFilter();
	
	for(var placeId in productPlaces){
		if(productPlaces[placeId] && typeof(productPlaces[placeId])!='function'){
			rebuildProducts(placeId, setList!=false?setList:1);
		}
	}
	
	setList = false;
	
}
var lastOnPageObj = false;
function setOnPageProducts(obj, productsPlaceId){
	
	var a = obj.parentNode.parentNode.getElementsByTagName('a');
	for(var i in a){
		if(a[i] && a[i].className=='spSelect'){
			a[i].className = '';
		}
	}
	
	lastOnPageObj = obj;
	obj.className = 'spSelect';
	
	productPlaces[productsPlaceId]['on_page'] = parseInt(obj.innerHTML);
	rebuildProducts(productsPlaceId, 1);
	
	return false;
	
}

var lastSortingMethodObj = false;
function setSortingMethod(obj, field, productsPlaceId){
	
	if(lastSortingMethodObj){
		lastSortingMethodObj.className = '';
	}
	
	lastSortingMethodObj = obj;
	obj.className = 'prodFilterBoxTextOn';
	
	if(productPlaces[productsPlaceId]['sort_by']==field){
		productPlaces[productsPlaceId]['sort_method'] = productPlaces[productsPlaceId]['sort_method']=='asc'?'desc':'asc';
	}else{
		productPlaces[productsPlaceId]['sort_by'] = field;
		productPlaces[productsPlaceId]['sort_method'] = 'asc';
	}
	
	rebuildProducts(productsPlaceId, 1);
	
	return false;
	
}

function setSearch(searchWord){
	
	for(var placeId in productPlaces){
		if(productPlaces[placeId] && typeof(productPlaces[placeId])!='function'){
			productPlaces[placeId]['search'] = searchWord;
		}
	}
	
	rebuildAllProducts();
	
}


function rebuildProducts(productsPlaceId, list){
	
	var itemsBox = document.getElementById('itemsBox_'+productsPlaceId);
	var topListNumbers = document.getElementById('topListNumbers_'+productsPlaceId);
	var bottomListNumbers = document.getElementById('bottomListNumbers_'+productsPlaceId);
	var itemsSorter = document.getElementById('itemsSorter_'+productsPlaceId);
	
	var foundEANCodes = {};
	
	if(itemsBox){
		
		if(productPlaces[productsPlaceId]['list_type']){
			//itemsBox.className = productPlaces[productsPlaceId]['list_type']=='list'?'shopProdBox prodList':'shopProdBox prodAll';
		}
		
		var searchWord = productPlaces[productsPlaceId]['search']?(productPlaces[productsPlaceId]['search'].toLowerCase()):false;
		var filteredProducts = [];
		
		for(var i in showedProducts){
			
			if(showedProducts[i]['obj'] && document.getElementById(showedProducts[i]['obj']) && showedProducts[i]['category']==productsPlaceId){
				
				var obj = document.getElementById(showedProducts[i]['obj']);
				
				obj.style.display = 'none';
				temporaryBox.appendChild(obj);
				
				productVisible = true;
				
				//-------- Searching name ----------|
					
					if(searchWord && ((showedProducts[i]['name'].toLowerCase()).indexOf(searchWord)==-1 && (showedProducts[i]['product_id'].toLowerCase()).indexOf(searchWord)==-1)){
						productVisible = false;
					}
					
				//-------- Searching name ----------|
				
				if(productVisible){
					if(countProperties(selectedFieldVariants) && countProperties(activeFilterFields)){
						
						for(var filterName in activeFilterFields){
							if(activeFilterFields.hasOwnProperty(filterName) && selectedFieldVariants[filterName]){
								if(!selectedFieldVariants[filterName][showedProducts[i]['filter_params'][filterName]]){
									productVisible = false;
								}
							}
						}
						
					}
				}
				
				//-------- Grouping products ----------|
					
					if(productVisible && showedProducts[i]['ean']){
						
						if(!foundEANCodes[showedProducts[i]['ean']]){
							foundEANCodes[showedProducts[i]['ean']] = true;
						}else{
							productVisible = false;
						}
						
					}
					
				//-------- Grouping products ----------|
				
				if(productVisible){
					filteredProducts.push(showedProducts[i]);
				}
				
			}
			
		}
		
		//---------- Generating URL -------------|
			
			var url = '';
				
				if(countProperties(selectedFieldVariants)){
					
					for(var filterName in selectedFieldVariants){
						
						if(selectedFieldVariants.hasOwnProperty(filterName)){
							
							var variants = '';
								
								for(var variantName in selectedFieldVariants[filterName]){
									
									if(selectedFieldVariants[filterName].hasOwnProperty(variantName)){
										
										variants += (variants?'||':'')+variantName;
										
									}
									
								}
								
							
							if(variants){
								url += (url?'&':'')+encodeURIComponent(filterName)+'='+encodeURIComponent(variants);
							}
							
						}
						
					}
					
				}
				
			
			var tmpUrl = location.href.split('#');
			if(tmpUrl[0]){
				location.href = tmpUrl[0]+'#'+(productPlaces[productsPlaceId]['sort_by']?('sort_by='+productPlaces[productsPlaceId]['sort_by']+'&sort_method='+productPlaces[productsPlaceId]['sort_method']+'&'):'')+(productPlaces[productsPlaceId]['list_type']?('list_type='+productPlaces[productsPlaceId]['list_type']):'')+'&price='+parseInt(document.getElementById('minCost').value)+'-'+parseInt(document.getElementById('maxCost').value)+'&onpage='+productPlaces[productsPlaceId]['on_page']+'&list='+list+(url?'&':'')+url;
			}
			
		//---------- Generating URL -------------|
		
		var lists = Math.ceil(filteredProducts.length/productPlaces[productsPlaceId]['on_page'])+1;
		
		//------ Setting numbers -------|
			
			if(topListNumbers){topListNumbers.innerHTML = '';}
			if(bottomListNumbers){bottomListNumbers.innerHTML = '';}
			
			if(lists>2){
				
				for(var i=1;i<lists;i++){
					
					if(topListNumbers){
						
						var a = document.createElement('a');
							
							if(i==list){
								a.className = 'num_on';
							}
							
							a.href = '';
							a.setAttribute('list', i);
							a.setAttribute('productsPlaceId', productsPlaceId);
							a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
							a.appendChild(document.createTextNode(i));
							
						topListNumbers.appendChild(a);
						
					}
					
					if(bottomListNumbers){
						
						if(i>2){
							
							var li = document.createElement('li');
							li.innerHTML = '|';
							bottomListNumbers.appendChild(li);
							
						}
						
						var li = document.createElement('li');
						li.className = i==list?'num_on':'';
							
							var a = document.createElement('a');
								
								a.href = '';
								a.setAttribute('list', i);
								a.setAttribute('productsPlaceId', productsPlaceId);
								a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
								a.appendChild(document.createTextNode(i));
								
							li.appendChild(a);
							
						bottomListNumbers.appendChild(li);
						
					}
					
				}
				
			}
			
		//------ Setting numbers -------|
		
		
		//------ Sorting products -------|
			
			if(productPlaces[productsPlaceId]['sort_by'] && productPlaces[productsPlaceId]['sort_by']!='-' && productPlaces[productsPlaceId]['sort_method']){
				
				if(productPlaces[productsPlaceId]['sort_by']=='quantity'){
					
					if(productPlaces[productsPlaceId]['sort_method']=='desc'){
						var sortFunction = function(a,b){return b['quantity'] - a['quantity']};
					}else{
						var sortFunction = function(a,b){return a['quantity'] - b['quantity']};
					}
					
				}else if(productPlaces[productsPlaceId]['sort_by']=='rating'){
					
					if(productPlaces[productsPlaceId]['sort_method']=='desc'){
						var sortFunction = function(a,b){return b['rating'] - a['rating']};
					}else{
						var sortFunction = function(a,b){return a['rating'] - b['rating']};
					}
					
				}else if(productPlaces[productsPlaceId]['sort_by']=='price'){
					
					if(productPlaces[productsPlaceId]['sort_method']=='desc'){
						var sortFunction = function(a,b){return b['price'] - a['price']};
					}else{
						var sortFunction = function(a,b){return a['price'] - b['price']};
					}
					
				}else if(productPlaces[productsPlaceId]['sort_by']=='name'){
					
					if(productPlaces[productsPlaceId]['sort_method']=='desc'){
						var sortFunction = function(a,b){
							
							if(b['name'] > a['name']){
								return -1;
							}else if (b['name'] < a['name']){
								return 1;
							}else{
								return 0;
							}
							
						};
					}else{
						var sortFunction = function(a,b){
							
							if(b['name'] > a['name']){
								return 1;
							}else if (b['name'] < a['name']){
								return -1;
							}else{
								return 0;
							}
							
						};
					}
					
				}
				
				filteredProducts = filteredProducts.sort(sortFunction);
				
			}
			
		//------ Sorting products -------|
		
		
		var from = (list-1)*productPlaces[productsPlaceId]['on_page'];
		var to = parseInt(from)+parseInt(productPlaces[productsPlaceId]['on_page']);
		
		filteredProducts = filteredProducts.slice(from, to);
		
		itemsBox.innerHTML = '';
		
		for(var i in filteredProducts){
			if(filteredProducts[i]['obj']){
				
				var obj = document.getElementById(filteredProducts[i]['obj']);
				obj.style.display = '';
				
				itemsBox.appendChild(obj);
				
			}
		}
		
		if(itemsSorter){
			itemsSorter.style.display = itemsBox.innerHTML?'':'none';
		}
		
	}
	
}



var timeStamp = false, favoritesFrame = false;

function updateFavorites(obj, itemInfo){
	
	if(!favoritesFrame){
		favoritesFrame = document.createElement('iframe');
		favoritesFrame.style.cssText = 'position:absolute;left:-100px;top:-100px;width:1px;height:1px;';
		document.body.appendChild(favoritesFrame);
	}
	
	if(itemInfo){
		obj.className = obj.className=='ibbStar'?'ibbStar on':'ibbStar';
		var is_favorite = (obj.className=='ibbStar on'?'true':'false');
	}else{
		obj.className = obj.className=='starBox'?'starBox on':'starBox';
		var is_favorite = (obj.className=='starBox on'?'true':'false');
	}
	
	timeStamp = Math.round(+new Date()/1000);
	favoritesFrame.src = '/?item='+obj.name+'&favorite='+is_favorite+'&'+timeStamp;
	
	return false;
	
}


function setTaxShowing(obj){
	
	if(!favoritesFrame){
		favoritesFrame = document.createElement('iframe');
		favoritesFrame.style.cssText = 'position:absolute;left:-100px;top:-100px;width:1px;height:1px;';
		document.body.appendChild(favoritesFrame);
	}
	
	timeStamp = Math.round(+new Date()/1000);
	favoritesFrame.src = '/?pricesWithTax='+(obj.checked?'true':'false')+'&'+timeStamp;
	
	document.getElementById('pagewrap').className = (obj.checked?'prices_with_tax':'prices_without_tax');
	
}


function setListType(obj, field, productsPlaceId){
	
	if(!favoritesFrame){
		favoritesFrame = document.createElement('iframe');
		favoritesFrame.style.cssText = 'position:absolute;left:-100px;top:-100px;width:1px;height:1px;';
		document.body.appendChild(favoritesFrame);
	}
	
	timeStamp = Math.round(+new Date()/1000);
	favoritesFrame.src = '/?listType='+(field=='list'?'list':'block')+'&'+timeStamp;
	
	
	
	var a = obj.parentNode.getElementsByTagName('a');
	a[0].className = 'listBlock';
	a[1].className = 'listList';
	
	obj.className = obj.className+' listSelect';
	
	if(productPlaces[productsPlaceId]['list_type']!=field){
		productPlaces[productsPlaceId]['list_type'] = field;
	}
	
	rebuildProducts(productsPlaceId, 1);
	
	return false;
	
}








var basketClass = function(){
	
	var lastPopUpNotice = false;
	var noticesId = 1;
	
	this.addItem = function(obj, id, quantity){
		
		var havePopUp = false;
		
		var div = obj.getElementsByTagName('div');
		for(var i in div){
			if(div[i] && div[i].className && div[i].className.indexOf('popUpNotice')!=-1){
				havePopUp = true;
			}
		}
		
		if(!havePopUp){
			
			var to_basket = [];
			to_basket[id] = quantity;
			
			if(lastPopUpNotice){
				lastPopUpNotice.className = 'popUpNotice';
			}
			
			//----- Sending save request ------|
				
				var req = new JsHttpRequest();
				
				req.onreadystatechange = function(){
					if(req.readyState == 4){
						
						if(req.responseJS['notice']){
							
							noticePopUp = document.createElement('div');
								
								noticePopUp.id = 'noticePopUp'+noticesId;
								noticePopUp.className = 'popUpNotice';
								
							
							for(var i in req.responseJS['notice']){
								
								var p = document.createElement('p');
								p.innerHTML = req.responseJS['notice'][i];
								noticePopUp.appendChild(p);
								
							}
							
							obj.appendChild(noticePopUp);
							setTimeout("document.getElementById('noticePopUp"+noticesId+"').className = 'popUpNotice popUpNoticeVisible';", 50);
							setTimeout("document.getElementById('noticePopUp"+noticesId+"').className = 'popUpNotice';", 4000);
							setTimeout("document.getElementById('noticePopUp"+noticesId+"').parentNode.removeChild(document.getElementById('noticePopUp"+noticesId+"'));", 5000);
							
							lastPopUpNotice = noticePopUp;
							
							noticesId++;
							
						}
						
						if(req.responseJS['error']){
							
							noticePopUp = document.createElement('div');
								
								noticePopUp.id = 'noticePopUp'+noticesId;
								noticePopUp.className = 'popUpNotice';
								
							
							for(var i in req.responseJS['error']){
								
								var p = document.createElement('p');
								p.innerHTML = req.responseJS['error'][i];
								noticePopUp.appendChild(p);
								
							}
							
							obj.appendChild(noticePopUp);
							setTimeout("document.getElementById('noticePopUp"+noticesId+"').className = 'popUpNotice popUpNoticeVisible';", 50);
							setTimeout("document.getElementById('noticePopUp"+noticesId+"').className = 'popUpNotice';", 4000);
							setTimeout("document.getElementById('noticePopUp"+noticesId+"').parentNode.removeChild(document.getElementById('noticePopUp"+noticesId+"'));", 5000);
							
							lastPopUpNotice = noticePopUp;
							
							noticesId++;
							
						}
						
						document.getElementById('basketItemsQty').innerHTML = req.responseJS['total_quantity'];
						
					}
				}
				
				req.caching = false;
				req.open('POST', './?jsRequest', true);
				req.send({'jsRequest': true, 'to_basket': to_basket});
				
			//----- Sending save request ------|
			
			return false;
			
		}
		
		return true;
		
	}
	
	this.getItems = function(){
		
		
		
	}
	
}

var basket = new basketClass();


*/

























	//------------ Product catalogue functions ------------|
		
		function countProperties(obj) {
			var count = 0;
			for(var prop in obj){if(obj.hasOwnProperty(prop)){++count};}
			return count;
		}
		
		function numericSort(a, b){ return (parseFloat(a)-parseFloat(b)); }
		
		var temporaryBox = false;
		
		var show_filter = true;
		var pageProducts = [];
		var productPlaces = [];
		var showedProducts = [];
		var selectedFieldVariants = [];
		
		var filterFields, activeFilterFields;
		
		var getParamsFromUrl = true;
		var setList = false;
		
		function rebuildFilter(){
			
			if(getParamsFromUrl){
				
				getParamsFromUrl = false;
				
				var params = location.href.split('#');
				if(params[1]){
					
					var list = false;
					
					params = params[1].split('&');
					
					for(var i in params){
						
						if(params.hasOwnProperty(i) && typeof(params[i][1])!='object' && typeof(params[i][1])!='function'){
							
							params[i] = params[i].split('=');
							
							if(params[i][1] && params[i][0]!='sort_by' && params[i][0]!='sort_method' && params[i][0]!='onpage' && params[i][0]!='list' && params[i][0]!='price'){
								
								params[i][0] = decodeURIComponent(params[i][0]);
								params[i][1] = decodeURIComponent(params[i][1]);
								
								params[i][1] = params[i][1].split('||');
								
								selectedFieldVariants[params[i][0]] = [];
								
								for(var x in params[i][1]){
									if(params[i][1].hasOwnProperty(x) && typeof(params[i][1][x])!='object' && typeof(params[i][1][x])!='function'){
										selectedFieldVariants[params[i][0]][params[i][1][x]] = true;
									}
								}
								
							}else if(params[i][0]=='onpage'){
								
								for(var x in productPlaces){
									if(productPlaces.hasOwnProperty(x)){
										productPlaces[x]['on_page'] = parseInt(params[i][1]);
									}
								}
								
							}else if(params[i][0]=='sort_by'){
								
								for(var x in productPlaces){
									if(productPlaces.hasOwnProperty(x)){
										productPlaces[x]['sort_by'] = params[i][1];
									}
								}
								
							}else if(params[i][0]=='sort_method'){
								
								for(var x in productPlaces){
									if(productPlaces.hasOwnProperty(x)){
										productPlaces[x]['sort_method'] = params[i][1];
									}
								}
								
							}else if(params[i][0]=='list'){
								
								setList = parseInt(params[i][1]);
								
							}else if(params[i][0]=='price'){
								
								var tmp = params[i][1].split('-');
								
								document.getElementById('minCost').value = parseInt(tmp[0]);
								document.getElementById('maxCost').value = parseInt(tmp[1]);
								
								/* jQuery("#priceSlider").slider({
									values: [tmp[0], tmp[1]]
								}); */
								
							}
							
						}
						
					}
					
				}
				
			}
			
			if(!pageProducts || !pageProducts.length){return false;}
			
			if(!temporaryBox){temporaryBox = document.getElementById('temporaryBox');}
			if(!filterForm){filterForm = document.getElementById('filterForm');}
			if(!fieldFilters){fieldFilters = document.getElementById('fieldFilters');}
			
			//----------- Getting filter fields -------------|
				
				filterFields = [];
				
				for(var i in filterForm.elements){
					if(typeof(filterForm.elements[i])=='object' && filterForm.elements[i] && filterForm.elements[i].name){
						filterFields[filterForm.elements[i].name] = filterForm.elements[i].value;
					}
				}
				
			//----------- Getting filter fields -------------|
			
			
			//--------- Searching products in price range ----------|
				
				showedProducts = [];
				
				for(var i in pageProducts){
					
					if(pageProducts[i]['obj'] && document.getElementById(pageProducts[i]['obj'])){
						
						var obj = document.getElementById(pageProducts[i]['obj']);
						
						obj.style.display = 'none';
						temporaryBox.appendChild(obj);
						
						productVisible = false;
						
						if(pageProducts[i]['price']>=filterFields['minCost'] && pageProducts[i]['price']<=filterFields['maxCost']){
							productVisible = true;
						}
						
						if(productVisible){
							showedProducts.push(pageProducts[i]);
						}
						
					}
					
				}
				
			//--------- Searching products in price range ----------|
			
			
			
			//--------- Generating filter fields ----------|
				
				filterFields = [];
				activeFilterFields = [];
				
				for(var i in showedProducts){
					
					if(showedProducts[i]['obj'] && showedProducts[i]['filter_params']){
						for(var field in showedProducts[i]['filter_params']){
							
							if(!filterFields[field]){
								filterFields[field] = [];
							}
							
							filterFields[field][showedProducts[i]['filter_params'][field]] = true;
							
						}
					}
				}
				
				fieldFilters.innerHTML = '';
				
				for(var fieldName in filterFields){
					
					if(filterFields[fieldName] && typeof(filterFields[fieldName])=='object' && countProperties(filterFields[fieldName])>1){
						
						activeFilterFields[fieldName] = true;
						
						/*
						
							<brand><div class="filtr_item">
								<h5 class="filtr_show">{word:brand}</h5>
								
								
								
								<ul class="filtr_item__list">
									<variant_selected><li class="filtr_item__on"><a href="{href}">{name}</a></li></variant_selected>
									<variant><li><a href="{href}">{name}</a></li></variant>
								</ul>
							</div></brand>
						
						*/
						
						var mainDiv = document.createElement('div');
						mainDiv.className = 'filtr_item';
							
							/* var h5 = document.createElement('h5');
								
								if(field_helps[fieldName]){
									
									var div = document.createElement('div');
										
										div.className = 'helpFilter';
										div.innerHTML = field_helps[fieldName];
										
									h5.appendChild(div);
									
								}
								
								h5.className = (!hide_fields[fieldName])?'filtr_show':'filtr_hide';
								h5.onclick = function(){return showFilter(this);}
								h5.appendChild(document.createTextNode(fieldName));
								
							mainDiv.appendChild(h5); */
							// Создаем input checkbox
							var input = document.createElement('input');
							input.type = 'checkbox';
							input.name = 'fi_' + fieldName; // предполагая, что fieldName это id записи
							input.id = 'fi_' + fieldName;
							input.className = 'visually_hidden';

							// Создаем label
							var label = document.createElement('label');
							label.htmlFor = 'fi_' + fieldName;
							label.className = (!hide_fields[fieldName]) ? 'filtr_show' : 'filtr_hide';

							// Добавляем текст в label (fieldName или другое имя из базы)
							label.appendChild(document.createTextNode(fieldName)); // или другое имя, если fieldName это id

							// Если есть подсказка, добавляем ее
							if(field_helps[fieldName]){
								var div = document.createElement('div');
								div.className = 'helpFilter';
								div.innerHTML = field_helps[fieldName];
								
								// Добавляем подсказку к label (или можно добавить к другому месту)
								label.appendChild(div);
							}

							// Добавляем обработчик клика на label
							label.onclick = function(){return showFilter(this);}

							// Добавляем элементы в основной div
							mainDiv.appendChild(input);
							mainDiv.appendChild(label);

							/* ------------------------------------------ */
							
							var ul = document.createElement('ul');
							ul.className = 'filtr_item__list';
							ul.style.display = (!hide_fields[fieldName])?'':'none';
								
								//----------- Resorting fields -----------|
									
									var tmpVariants = [];
									
									for(var variantName in filterFields[fieldName]){
										if(filterFields[fieldName][variantName] && typeof(filterFields[fieldName][variantName])!='function'){
											tmpVariants.push(variantName);
										}
									}
									
									if(parseFloat(tmpVariants[0]) && parseFloat(tmpVariants[1])){
										tmpVariants.sort(numericSort);
									}else{
										tmpVariants.sort();
									}
									
									
									var tmpVariants_new = [];
									
									for(var i in tmpVariants){
										if(tmpVariants[i] && typeof(tmpVariants[i])!='function'){
											tmpVariants_new[tmpVariants[i]] = true;
										}
									}
									
									filterFields[fieldName] = tmpVariants_new;
									
								//----------- Resorting fields -----------|
								
								for(var variantName in filterFields[fieldName]){
									
									if(filterFields[fieldName][variantName] && typeof(filterFields[fieldName][variantName])!='function' && variantName!='-'){
										
										var li = document.createElement('li');
										li.className = (selectedFieldVariants[fieldName] && selectedFieldVariants[fieldName][variantName])?'filtr_item__on':'';
											
											var a = document.createElement('a');
												
												var status = (selectedFieldVariants[fieldName] && selectedFieldVariants[fieldName][variantName])?'on':'off';
												
												a.setAttribute('field', fieldName);
												a.setAttribute('variant', variantName);
												a.setAttribute('status', status);
												a.onclick = function(){
													
													var newStatus = this.getAttribute('status')=='off'?'on':'off';
													this.setAttribute('status', newStatus);
													
													if(newStatus=='on'){
														if(!selectedFieldVariants[this.getAttribute('field')]){selectedFieldVariants[this.getAttribute('field')] = [];}
														selectedFieldVariants[this.getAttribute('field')][this.getAttribute('variant')] = true;
													}else if(selectedFieldVariants[this.getAttribute('field')][this.getAttribute('variant')]){
														delete selectedFieldVariants[this.getAttribute('field')][this.getAttribute('variant')];
														if(!countProperties(selectedFieldVariants[this.getAttribute('field')])){delete selectedFieldVariants[this.getAttribute('field')];}
													}
													
													rebuildAllProducts();
													
													return false;
													
												}
												
												a.href = location.href;
												a.appendChild(document.createTextNode(variantName));
												
											li.appendChild(a);
											
										ul.appendChild(li);
										
									}
									
								}
								
							mainDiv.appendChild(ul);
							
						fieldFilters.appendChild(mainDiv);
						
					}
					
				}
				
			//--------- Generating filter fields ----------|
			
		}
		
		var lastMaxScrollId = 0;
		
		/* if(!window.onscroll){
			
			window.onscroll = function(e){
				
				var scrolled = jQuery(window).scrollTop();
				var maxScroll = window.scrollMaxY?window.scrollMaxY:(document.documentElement.scrollHeight - document.documentElement.clientHeight);
				
				if(scrolled>32){
				   jQuery(".top_header").addClass("popup_top");
				   jQuery(".all_content").addClass("popup_top__pading");
				}else{
				   jQuery('.top_header').removeClass('popup_top');
				   jQuery(".all_content").removeClass("popup_top__pading");
				}
				
				
			}
			
		} */
		if (!window.onscroll) {
			window.onscroll = function(e) {
				var scrolled = window.pageYOffset || document.documentElement.scrollTop;
				var maxScroll = window.scrollMaxY ? window.scrollMaxY : (document.documentElement.scrollHeight - document.documentElement.clientHeight);
				
				var topHeader = document.querySelector('.top_header');
				var allContent = document.querySelector('.all_content');
				
				if (topHeader) {
					if (scrolled > 32) {
						topHeader.classList.add('popup_top');
					} else {
						topHeader.classList.remove('popup_top');
					}
				}
				
				if (allContent) {
					if (scrolled > 32) {
						allContent.classList.add('popup_top__pading');
					} else {
						allContent.classList.remove('popup_top__pading');
					}
				}
			};
		}
		
		function rebuildAllProducts(){
			
			rebuildFilter();
			
			for(var placeId in productPlaces){
				if(productPlaces[placeId] && typeof(productPlaces[placeId])!='function'){
					rebuildProducts(placeId, setList!=false?setList:1);
				}
			}
			
			setList = false;
			
		}
		
		function setOnPageProducts(obj, productsPlaceId){
			
			var a = obj.parentNode.parentNode.parentNode.parentNode.getElementsByTagName('a');
			a[a.length-1].innerHTML = parseInt(obj.innerHTML);
			
			productPlaces[productsPlaceId]['on_page'] = parseInt(obj.innerHTML);
			rebuildProducts(productsPlaceId, 1);
			
			return false;
			
		}
		
		function setSortingMethod(obj, field, productsPlaceId){
			
			var span = obj.parentNode.parentNode.parentNode.getElementsByTagName('span')[0];
			span.innerHTML = obj.innerHTML;
			
			if(productPlaces[productsPlaceId]['sort_by']==field){
				productPlaces[productsPlaceId]['sort_method'] = productPlaces[productsPlaceId]['sort_method']=='asc'?'desc':'asc';
			}else{
				productPlaces[productsPlaceId]['sort_by'] = field;
				productPlaces[productsPlaceId]['sort_method'] = 'asc';
			}
			
			rebuildProducts(productsPlaceId, 1);
			
			return false;
			
		}
		
		function rebuildProducts(productsPlaceId, list){
			
			var itemsBox = document.getElementById('itemsBox_'+productsPlaceId);
			var topListNumbers = document.getElementById('topListNumbers_'+productsPlaceId);
			var bottomListNumbers = document.getElementById('bottomListNumbers_'+productsPlaceId);
			var itemsSorter = document.getElementById('itemsSorter_'+productsPlaceId);
			
			if(itemsBox){
				
				itemsBox.style.display = '';
				var filteredProducts = [];
				
				for(var i in showedProducts){
					
					if(showedProducts[i]['obj'] && document.getElementById(showedProducts[i]['obj']) && showedProducts[i]['category']==productsPlaceId){
						
						var obj = document.getElementById(showedProducts[i]['obj']);
						
						obj.style.display = 'none';
						temporaryBox.appendChild(obj);
						
						productVisible = true;
						
						if(countProperties(selectedFieldVariants) && countProperties(activeFilterFields)){
							
							for(var filterName in activeFilterFields){
								if(activeFilterFields.hasOwnProperty(filterName) && selectedFieldVariants[filterName]){
									if(!selectedFieldVariants[filterName][showedProducts[i]['filter_params'][filterName]]){
										productVisible = false;
									}
								}
							}
							
						}
						
						if(productVisible){
							filteredProducts.push(showedProducts[i]);
						}
						
					}
					
				}
				
				
				//---------- Generating URL -------------|
					
					var url = '';
						
						if(countProperties(selectedFieldVariants)){
							
							for(var filterName in selectedFieldVariants){
								
								if(selectedFieldVariants.hasOwnProperty(filterName)){
									
									var variants = '';
										
										for(var variantName in selectedFieldVariants[filterName]){
											
											if(selectedFieldVariants[filterName].hasOwnProperty(variantName)){
												
												variants += (variants?'||':'')+variantName;
												
											}
											
										}
										
									
									if(variants){
										url += (url?'&':'')+encodeURIComponent(filterName)+'='+encodeURIComponent(variants);
									}
									
								}
								
							}
							
						}
						
					
					var tmpUrl = location.href.split('#');
					if(tmpUrl[0]){
						location.href = tmpUrl[0]+'#'+(productPlaces[productsPlaceId]['sort_by']?('sort_by='+productPlaces[productsPlaceId]['sort_by']+'&sort_method='+productPlaces[productsPlaceId]['sort_method']+'&'):'')+'&price='+parseInt(document.getElementById('minCost').value)+'-'+parseInt(document.getElementById('maxCost').value)+'&onpage='+productPlaces[productsPlaceId]['on_page']+'&list='+list+(url?'&':'')+url;
					}
					
				//---------- Generating URL -------------|
				
				var lists = Math.ceil(filteredProducts.length/productPlaces[productsPlaceId]['on_page'])+1;
				
				//------ Setting numbers -------|
					
					if(topListNumbers){topListNumbers.innerHTML = '';}
					if(bottomListNumbers){bottomListNumbers.innerHTML = '';}
					
					if(lists>2){
						
						/*
						//--------- First list Arrow ----------|	
							
							if(topListNumbers){
								
								var li = document.createElement('li');
									
									li.className = 'arrowLeft';
									
									var a = document.createElement('a');
										
										a.href = '';
										a.innerHTML = '&nbsp;';
										a.setAttribute('list', 1);
										a.setAttribute('productsPlaceId', productsPlaceId);
										a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
										
									li.appendChild(a);
									
								topListNumbers.appendChild(li);
								
							}
							
							if(bottomListNumbers){
								
								var li = document.createElement('li');
									
									li.className = 'arrowLeft';
									
									var a = document.createElement('a');
										
										a.href = '';
										a.innerHTML = '&nbsp;';
										a.setAttribute('list', 1);
										a.setAttribute('productsPlaceId', productsPlaceId);
										a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
										
									li.appendChild(a);
									
								bottomListNumbers.appendChild(li);
								
							}
							
						//--------- First list Arrow ----------|
						
						//--------- Previous list Arrow ----------|	
							
							if(topListNumbers){
								
								var li = document.createElement('li');
									
									li.className = 'arrowLeftS';
									
									var a = document.createElement('a');
										
										a.href = '';
										a.innerHTML = '&nbsp;';
										a.setAttribute('list', (list-1>1?list-1:1));
										a.setAttribute('productsPlaceId', productsPlaceId);
										a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
										
									li.appendChild(a);
									
								topListNumbers.appendChild(li);
								
							}
							
							if(bottomListNumbers){
								
								var li = document.createElement('li');
									
									li.className = 'arrowLeftS';
									
									var a = document.createElement('a');
										
										a.href = '';
										a.innerHTML = '&nbsp;';
										a.setAttribute('list', (list-1>1?list-1:1));
										a.setAttribute('productsPlaceId', productsPlaceId);
										a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
										
									li.appendChild(a);
									
								bottomListNumbers.appendChild(li);
								
							}
							
						//--------- Previous list Arrow ----------|
						*/
						
						for(var i=1;i<lists;i++){
							
							if(topListNumbers){
								
								var li = document.createElement('li');
									
									if(i==list){
										li.className = 'num_on';
									}
									
									var a = document.createElement('a');
										
										a.href = '';
										a.setAttribute('list', i);
										a.setAttribute('productsPlaceId', productsPlaceId);
										a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
										a.appendChild(document.createTextNode(i));
										
									li.appendChild(a);
									
								topListNumbers.appendChild(li);
								
							}
							
							if(bottomListNumbers){
								
								var li = document.createElement('li');
									
									if(i==list){
										li.className = 'num_on';
									}
									
									var a = document.createElement('a');
										
										a.href = '';
										a.setAttribute('list', i);
										a.setAttribute('productsPlaceId', productsPlaceId);
										a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
										a.appendChild(document.createTextNode(i));
										
									li.appendChild(a);
									
								bottomListNumbers.appendChild(li);
								
							}
							
						}
						
						/*
						//--------- Next list Arrow ----------|	
							
							if(topListNumbers){
								
								var li = document.createElement('li');
									
									li.className = 'arrowRightS';
									
									var a = document.createElement('a');
										
										a.href = '';
										a.innerHTML = '&nbsp;';
										a.setAttribute('list', (list+1<lists?list+1:lists-1));
										a.setAttribute('productsPlaceId', productsPlaceId);
										a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
										
									li.appendChild(a);
									
								topListNumbers.appendChild(li);
								
							}
							
							if(bottomListNumbers){
								
								var li = document.createElement('li');
									
									li.className = 'arrowRightS';
									
									var a = document.createElement('a');
										
										a.href = '';
										a.innerHTML = '&nbsp;';
										a.setAttribute('list', (list+1<=lists?list+1:lists-1));
										a.setAttribute('productsPlaceId', productsPlaceId);
										a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
										
									li.appendChild(a);
									
								bottomListNumbers.appendChild(li);
								
							}
							
						//--------- Next list Arrow ----------|
						
						//--------- Last list Arrow ----------|	
							
							if(topListNumbers){
								
								var li = document.createElement('li');
									
									li.className = 'arrowRight';
									
									var a = document.createElement('a');
										
										a.href = '';
										a.innerHTML = '&nbsp;';
										a.setAttribute('list', lists-1);
										a.setAttribute('productsPlaceId', productsPlaceId);
										a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
										
									li.appendChild(a);
									
								topListNumbers.appendChild(li);
								
							}
							
							if(bottomListNumbers){
								
								var li = document.createElement('li');
									
									li.className = 'arrowRight';
									
									var a = document.createElement('a');
										
										a.href = '';
										a.innerHTML = '&nbsp;';
										a.setAttribute('list', lists-1);
										a.setAttribute('productsPlaceId', productsPlaceId);
										a.onclick = function(){rebuildProducts(this.getAttribute('productsPlaceId'), parseInt(this.getAttribute('list')));return false;}
										
									li.appendChild(a);
									
								bottomListNumbers.appendChild(li);
								
							}
							
						//--------- Last list Arrow ----------|
						*/
						
					}
					
				//------ Setting numbers -------|
				
				
				//------ Sorting products -------|
					
					if(productPlaces[productsPlaceId]['sort_by'] && productPlaces[productsPlaceId]['sort_by']!='-' && productPlaces[productsPlaceId]['sort_method']){
						
						if(productPlaces[productsPlaceId]['sort_by']=='price'){
							
							if(productPlaces[productsPlaceId]['sort_method']=='desc'){
								var sortFunction = function(a,b){return b['price'] - a['price']};
							}else{
								var sortFunction = function(a,b){return a['price'] - b['price']};
							}
							
						}else if(productPlaces[productsPlaceId]['sort_by']=='name'){
							
							if(productPlaces[productsPlaceId]['sort_method']=='desc'){
								var sortFunction = function(a,b){
									
									if(b['name'] > a['name']){
										return -1;
									}else if (b['name'] < a['name']){
										return 1;
									}else{
										return 0;
									}
									
								};
							}else{
								var sortFunction = function(a,b){
									
									if(b['name'] > a['name']){
										return 1;
									}else if (b['name'] < a['name']){
										return -1;
									}else{
										return 0;
									}
									
								};
							}
							
						}
						
						filteredProducts = filteredProducts.sort(sortFunction);
						
					}
					
				//------ Sorting products -------|
				
				var from = (list-1)*productPlaces[productsPlaceId]['on_page'];
				var to = parseInt(from)+parseInt(productPlaces[productsPlaceId]['on_page']);
				
				filteredProducts = filteredProducts.slice(from, to);
				itemsBox.innerHTML = '';
				
				for(var i in filteredProducts){
					if(filteredProducts[i]['obj']){
						
						var obj = document.getElementById(filteredProducts[i]['obj']);
						obj.style.display = '';
						
						itemsBox.appendChild(obj);
						
					}
				}
				
				itemsSorter.style.display = itemsBox.innerHTML?'':'none';
				
			}
			
		}
		
	//------------ Product catalogue functions ------------|


	//-------------- Fast search ---------------|	
		
		var searchResultArea, searchResultArea, intervalTimer = false, intervalTime = 0;
		
		var fastFoundProducts;
		
		function fastSearch(input, fastSearchResults, fastFoundProducts, fastFoundCategories, fastFoundFilters){
			
			searchItemsArea = document.getElementById(fastSearchResults);
			if(searchItemsArea){
				
				if(!input.onblur){
					input.onblur = function(){
						setTimeout(function(){
							searchItemsArea.style.display = 'none';
						}, 200);
					};
				}
				
				searchItemsArea.style.display = 'none';
				
				fastFoundProducts = document.getElementById(fastFoundProducts);
				fastFoundProducts.innerHTML = '';
				
				fastFoundCategories = document.getElementById(fastFoundCategories);
				fastFoundCategories.innerHTML = '';
				
				fastFoundFilters = document.getElementById(fastFoundFilters);
				fastFoundFilters.innerHTML = '';
				
				if(!intervalTimer){
					
					intervalTimer = setInterval(function(){
						
						if(!intervalTime){
							
							//--------- Getting search results ----------|
								
								var req = new JsHttpRequest();
								req.onreadystatechange = function(){
									if(req.readyState == 4){
										
										if(req.responseText && document.getElementById('debug')){
											document.getElementById('debug').innerHTML = req.responseText;
										}
										
										if(req.responseJS.items){
											
											searchItemsArea.style.display = '';
											
											fastFoundProducts.innerHTML = '';
												
												for(var i in req.responseJS.items){
													
													var item = req.responseJS.items[i];
													
													var li = document.createElement('li');
														
														var a = document.createElement('a');
														a.href = item['href'];
														a.alt = item['title'];
														a.title = item['title'];
															
															var img = document.createElement('img');
															img.src = '/templates/datagate2025/images/spacer.png';
															img.style.backgroundImage = "url('"+item['image']+"')";
															a.appendChild(img);
															
															if(item['b'] && item['b']=='miele'){
																var span = document.createElement('span');
																span.className = 's_brand s_MIELE';
																a.appendChild(span);
															}
															
															var span = document.createElement('span');
															span.innerHTML = item['title'];
															a.appendChild(span);
															
														li.appendChild(a);
														
													fastFoundProducts.appendChild(li);
													
												}
												
											fastFoundProducts.parentNode.style.display = req.responseJS.items.length>0?'':'none';
											
											fastFoundCategories.innerHTML = '';
												
												for(var i in req.responseJS.categories){
													
													var category = req.responseJS.categories[i];
													
													var li = document.createElement('li');
														
														var a = document.createElement('a');
														a.href = category['href'];
														a.alt = category['name'];
														a.title = category['name'];
															
															var span = document.createElement('span');
															span.innerHTML = category['name'];
															a.appendChild(span);
															
														li.appendChild(a);
														
													fastFoundCategories.appendChild(li);
													
												}
												
											fastFoundCategories.parentNode.style.display = req.responseJS.categories.length>0?'':'none';
											
											fastFoundFilters.innerHTML = '';
												
												for(var i in req.responseJS.filters){
													
													var filter = req.responseJS.filters[i];
													
													var li = document.createElement('li');
														
														var a = document.createElement('a');
														a.href = filter['href'];
														a.alt = filter['name'];
														a.title = filter['name'];
															
															var span = document.createElement('span');
															span.innerHTML = filter['name']
															a.appendChild(span);
															
														li.appendChild(a);
														
													fastFoundFilters.appendChild(li);
													
												}
												
											fastFoundFilters.parentNode.style.display = req.responseJS.filters.length>0?'':'none';
											
											searchItemsArea.className = searchItemsArea.className.replace('ts_hide', 'ts_show');
											
										}
										
									}
								}
								
								req.caching = false;
								req.open('GET', './?', true);
								req.send({'fs': input.value});
								
							//--------- Getting search results ----------|
							
						}
						
						intervalTime--;
						
					}, 180);
					
				}
				
				intervalTime = 2;
				
			}
			
		}
		
	//-------------- Fast search ---------------|

